/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @next/next/no-img-element */
import React from 'react';
import styles from './styles.module.scss';
import { LANDING_PAGE_DATA } from '../config';
import parse from 'html-react-parser';
import CountUp from 'react-countup';

const Index = () => {
  const { claim_info_section } = LANDING_PAGE_DATA;

  return (
    <section className={styles.claimInfoSection}>
      <div>
        <div className={styles.sectionTitle} style={{ marginTop: '8px' }}>
          {parse(claim_info_section.title)}
        </div>
        <div className={styles.highlightText}>
          {claim_info_section.note_text}
        </div>
        <div className={styles.claimInfoCardStats}>
          {claim_info_section?.claim_info_list?.map((stat) => (
            <div className={styles.statItem} key={stat?.title}>
              <div className={styles.statValue}>
                <CountUp
                  end={Number(stat?.value)}
                  duration={8}
                  suffix={stat?.suffix}
                  delay={4}
                />
              </div>
              <div className={styles.statTitle}>{stat?.title}</div>
            </div>
          ))}
        </div>
      </div>
      <div className={styles.claimInfoCard}>
        <div>
          <div className={styles.claimInfoCardTitle}>
            {parse(claim_info_section?.card?.destop_title)}
          </div>
          <div className={styles.claimInfoCardSubtitle}>
            {claim_info_section?.card?.subtitle}
          </div>
        </div>
        <div className={styles.planeImageContainer}>
          <img
            src={claim_info_section?.card?.icon_url}
            height={'360px'}
            width={'250px'}
            alt="plane-with-trail"
          />
        </div>
      </div>
    </section>
  );
};

export default Index;
